import type { Layer, TemplateDoc } from '../template';

/** Reading order: top-level layers by position, stack children in stack order. */
export function readingOrder(doc: TemplateDoc): Layer[] {
  const byId = new Map(doc.layers.map((l) => [l.id, l]));
  const childIndex = new Map<string, number>();
  const counters = new Map<string, number>();
  for (const l of doc.layers) {
    if (!l.parentId) continue;
    const n = counters.get(l.parentId) ?? 0;
    childIndex.set(l.id, n);
    counters.set(l.parentId, n + 1);
  }
  const path = (l: Layer): number[] => {
    if (l.parentId && byId.has(l.parentId))
      return [...path(byId.get(l.parentId)!), childIndex.get(l.id) ?? 0];
    // Rows of ~5% of the canvas height, then left to right
    const row = Math.round((l.y + l.height / 2) / (doc.height * 0.05));
    return [row, l.x];
  };
  const keyed = doc.layers.map((l) => ({ l, k: path(l) }));
  keyed.sort((a, b) => {
    for (let i = 0; i < Math.max(a.k.length, b.k.length); i++) {
      const d = (a.k[i] ?? -1) - (b.k[i] ?? -1);
      if (d) return d;
    }
    return 0;
  });
  return keyed.map((x) => x.l);
}
